import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormGroup, FormControl, FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-comment-input',
  standalone: true,
  imports: [
    MatRadioModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    CommonModule,
    MatTooltipModule,
  ],
  templateUrl: './comment-input.component.html',
  styleUrl: './comment-input.component.css',
})
export class CommentInputComponent {
  @Input() activationLabel: string = 'Besvar';
  @Input() activationIcon: string = 'reply';

  @Input() submitLabel: string = 'Send';

  @ViewChild('commentTextarea') commentTextarea: ElementRef | undefined;

  @Output() submit = new EventEmitter<string>();

  showInput = false;

  comment: string = '';

  showInputField() {
    this.showInput = true;
    setTimeout(() => {
      this.commentTextarea?.nativeElement.focus();
    });
  }

  onSubmit() {
    this.submit.emit(this.comment);
    this.comment = '';
    this.showInput = false;
  }
}
